import { Component } from '@angular/core';

@Component({
    template: '<div class="flex justify-center items-center align-middle flex-row flex-wrap w-full h-full absolute"><span class="full-screen-loader"></span><div>',
    styleUrls: ['./full-screen-loader.component.scss'],
    selector: 'app-full-screen-loader'
})
export class FullScreenLoaderComponent {}
